if (!customElements.get('services-form')) {
    const PostalCodeForm = customElements.get('postal-code-form');

    if (PostalCodeForm) {
        customElements.define(
            'services-form',
            class ServicesForm extends PostalCodeForm {
                constructor() {
                    super();
                }

                connectedCallback() {
                    this.serviceConfig = [
                        {
                            id: "montage",
                            selector: ".js-services-form__option--montage",
                            price: this.assemblyCosts,
                            variantID: 53152211009879,
                        },
                        {
                            id: "wee",
                            selector: ".js-services-form__option--altgeraeteentsorgung_weee",
                            price: 0,
                            variantID: 53157768036695,
                        },
                        {
                            id: "altmoebel_mitnahme",
                            selector: ".js-services-form__option--altmoebelmitnahme",
                            price: 0, // TODO TDB
                            variantID: 53157771837783,
                        },
                    ];
                    this.input = this.querySelector('.js-services-form__input');
                    this.messages = this.querySelector('.js-services-form__messages');
                    this.messagesText = this.messages.querySelector('.js-form-message__text');
                    this.reset = this.querySelector('.js-services-form__reset');
                    this.results = this.querySelector('.js-services-form__results-wrapper');
                    this.loading = this.querySelector('.js-services-form__results__loading');
                    this.submitButton = this.querySelector('.js-services-form__submit-button');
                    this.modal = this.closest('basic-modal#services-drawer');

                    this.services = Object.fromEntries(
                        this.serviceConfig.map((service) => [service.id, this.querySelector(service.selector)])
                    );

                    this.inputChangeHandler = FoxTheme.utils.debounce(this.handleInputChange.bind(this), 500);
                    this.resetHandler = this.handleReset.bind(this);
                    this.modalAfterHideHandler = this.handleModalAfterHide.bind(this);
                    this.addServicesHandler = this.addServices.bind(this);

                    this.mapEvents();
                }

                disconnectedCallback() {
                    super.disconnectedCallback();

                    if (this.modal) {
                        this.modal.removeEventListener('modal:handleAfterHide', this.modalAfterHideHandler);
                    }
                }

                mapEvents() {
                    super.mapEvents();

                    if (this.modal) {
                        this.modal.addEventListener('modal:handleAfterHide', this.modalAfterHideHandler);
                        this.submitButton.setAttribute('aria-controls', this.modal.id);
                    }
                }

                handleModalAfterHide() {
                    if (this.results.classList.contains('hidden')) return;

                    FoxTheme.selectedServices = Object.keys(this.services)
                        .filter((key) => this.services[key] && this.services[key].checked)
                        .map((key) => {
                            const config = this.serviceConfig.find((service) => service.id === key);

                            return {
                                ...config,
                                price: this.getServicePrice(key),
                            };
                        });

                    this.updateTriggerSubtitle(FoxTheme.selectedServices);
                }

                handleInputChange(event) {
                    FoxTheme.selectedServices = [];
                    this.hideServices();
                    this.toggleError(false);
                    this.updateTriggerSubtitle([]);

                    if (!event.target.validity.valid) {
                        this.messagesText.textContent = this.messages.dataset.postalCodeErrorMessage;
                        this.toggleError(true);

                        return;
                    }

                    const value = event.target.value.trim();

                    if (value) {
                        this.fetchDeliveryInfo(value);
                        FoxTheme.selectedServicePostalCode = value;
                    }
                }

                handleReset(event) {
                    event.preventDefault();

                    FoxTheme.selectedServices = [];
                    FoxTheme.selectedServicePostalCode = '';
                    this.updateTriggerSubtitle([]);

                    this.toggleError(false);

                    this.input.value = '';
                    this.input.focus();

                    this.input.setAttribute('aria-invalid', 'false');
                    this.hideServices();
                }

                showServices(services) {
                    // n8n liefert Verfügbarkeit als flaches Objekt oder Array, z. B.
                    // { montage: true, weee: false } oder [{ montage: true, weee: false }].
                    const availability = Array.isArray(services)
                        ? Object.assign({}, ...services)
                        : (services || {});
                    const keyMap = { weee: 'wee' };
                    const availableServiceIds = Object.keys(availability)
                        .filter((key) => availability[key] === true)
                        .map((key) => keyMap[key] || key)
                        .filter((id) => this.services[id]);

                    let visibleServiceCount = 0;

                    availableServiceIds.forEach((serviceId) => {
                        const service = this.services[serviceId];
                        const listItem = service.closest('li.services-form__results__option');
                        const label = listItem?.querySelector('label');
                        const config = this.serviceConfig.find((entry) => entry.id === serviceId);

                        if (!config || !label || !listItem) return;
                        if (config.id === 'altmoebel_mitnahme') return;

                        const price = this.getServicePrice(serviceId);
                        const priceFormatted = FoxTheme.Currency.formatMoney(
                            price,
                            FoxTheme.settings.moneyFormat,
                        );

                        label.textContent = label.dataset.text.replace('%price%', priceFormatted);
                        listItem.classList.remove('hidden');
                        visibleServiceCount++;
                    });

                    if (visibleServiceCount === 0) {
                        this.messagesText.textContent = this.messages.dataset.noServicesAvailableMessage;
                        this.toggleError(true);
                        this.results.classList.add('hidden');

                        return;
                    }

                    this.toggleError(false);
                    this.results.classList.remove('hidden');
                    this.submitButton.addEventListener('click', this.addServicesHandler, false);
                    this.submitButton.setAttribute('type', 'submit');
                }

                hideServices() {
                    this.results.classList.add('hidden');

                    // Reset submit button to normal button that closes the form without submitting services
                    this.submitButton.removeEventListener('click', this.addServicesHandler, false);
                    this.submitButton.setAttribute('type', 'button');

                    // Uncheck all services and hide them
                    Object.values(this.services)
                        .filter(service => service !== null)
                        .forEach(service => {
                            service.checked = false;

                            const listItem = service.closest('li.services-form__results__option');
                            listItem.classList.add('hidden');
                        });
                }

                addServices(event) {
                    event.preventDefault();

                    FoxTheme.selectedServices = Object.keys(this.services)
                        .filter(key => this.services[key] && this.services[key].checked)
                        .map(key => {
                            const config = this.serviceConfig.find(service => service.id === key);

                            return {
                                ...config,
                                price: this.getServicePrice(key),
                            };
                        });

                    this.updateTriggerSubtitle(FoxTheme.selectedServices);
                }

                updateTriggerSubtitle(services) {
                    const subtitle = document.querySelector('.js-services-form__trigger-subtitle');

                    if (!subtitle) return;

                    const amount = services.length;
                    const price = services.reduce((acc, service) => acc + service.price, 0);
                    const priceFormatted = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);

                    const text = amount > 0
                        ? subtitle.dataset.textServices.replace('%amount%', amount).replace('%price%', priceFormatted)
                        : subtitle.dataset.textNoServices;

                    subtitle.textContent = text;
                }

                async fetchDeliveryInfo(postalCode) {
                    this.toggleLoadingSpinner(true);

                    const body = {
                        postal_code: postalCode,
                        shipping_method: this.carrier,
                        is_wall_mounting: this.wallMounting === 'true',
                        is_service: true,
                        sku: this.sku,
                    }

                    await fetch('https://hardeck.app.n8n.cloud/webhook/plz-check', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(body),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            this.showServices(data);
                        }).catch(() => {
                            this.messagesText.textContent = this.messages.dataset.noServicesAvailableMessage;
                            this.toggleError(true);
                            this.toggleLoadingSpinner(false);
                        })
                        .finally(() => {
                            this.toggleLoadingSpinner(false);
                        });
                }

                get carrier() {
                    return this.dataset.carrier;
                }

                get wallMounting() {
                    return this.dataset.wallMounting;
                }

                getServicePrice(serviceId) {
                    if (serviceId === 'montage') {
                        return this.assemblyCosts;
                    }

                    const config = this.serviceConfig.find((service) => service.id === serviceId);

                    return config?.price ?? 0;
                }

                get assemblyCosts() {
                    const raw = this.dataset.assemblyCosts?.trim();

                    if (!raw) return 0;

                    if (raw.startsWith('{')) {
                        try {
                            const { amount } = JSON.parse(raw);
                            const parsed = Number.parseFloat(amount);

                            return Number.isNaN(parsed) ? 0 : Math.round(parsed * 100);
                        } catch {
                            return 0;
                        }
                    }

                    const normalized = raw.replace(',', '.');

                    if (normalized.includes('.')) {
                        const parsed = Number.parseFloat(normalized);

                        return Number.isNaN(parsed) ? 0 : Math.round(parsed * 100);
                    }

                    const parsed = Number.parseInt(normalized, 10);

                    return Number.isNaN(parsed) ? 0 : parsed * 100;
                }
            }
        );
    }
}
